<ng-container *ngIf="data">
  <app-panels *ngIf="data.panels && data.panels.value" [items]="data.panels.value"></app-panels>
</ng-container>
